export enum ContactNotificationAction {
  Update = 'UPDATE'
}
